module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-1400.6307b1eb.svg";